import axios from "axios";

export const CUSTOMERS_URL = "api/giveaway";

axios.defaults.headers.post["Content-Type"] = "application/json";


// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findGiveaway(id) {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/giveaway/${id}`);
}

export function updateGiveaway(giveaway) {
  return axios.put(`${process.env.REACT_APP_API_URL}/api/giveaway/${giveaway._id}`, giveaway );
}

export function createGiveaway(giveaway) {
  return axios.post(`${process.env.REACT_APP_API_URL}/api/giveaway/`, giveaway);
}

